var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sidesheet" }, [
    _c("div", {
      staticClass: "sidesheet__overlay",
      class: { sidesheet__overlay_active: _vm.localActive },
    }),
    _c(
      "div",
      {
        staticClass: "sidesheet__wrapper",
        class: { sidesheet__wrapper_active: _vm.localActive },
      },
      [
        _c(
          "div",
          {
            staticClass: "sidesheet__close",
            on: { click: _vm.closeSidesheet },
          },
          [
            _c(
              "svg",
              {
                staticClass: "lg",
                attrs: {
                  width: "34",
                  height: "34",
                  viewBox: "0 0 34 34",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("circle", {
                  attrs: {
                    cx: "17",
                    cy: "17.001",
                    r: "16.5",
                    stroke: "#D3D8DF",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M22.9684 22.66C22.5794 23.049 21.9467 23.047 21.5552 22.6555L11.6584 12.7602C11.267 12.3687 11.265 11.736 11.654 11.347C12.043 10.9579 12.6758 10.9599 13.0672 11.3514L22.964 21.2468C23.3555 21.6382 23.3574 22.2709 22.9684 22.66Z",
                    fill: "#D3D8DF",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M22.9766 11.3502C22.5852 10.9587 21.9525 10.9567 21.5634 11.3458L11.6585 21.2507C11.2695 21.6397 11.2715 22.2724 11.6629 22.6639C12.0544 23.0554 12.6871 23.0574 13.0761 22.6683L22.9811 12.7634C23.3701 12.3744 23.3681 11.7417 22.9766 11.3502Z",
                    fill: "#D3D8DF",
                  },
                }),
              ]
            ),
            _c(
              "svg",
              {
                staticClass: "sm",
                attrs: {
                  width: "30",
                  height: "30",
                  viewBox: "0 0 15 15",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M10.6045 10.6092C10.2154 10.9983 9.58272 10.9963 9.19126 10.6048L3.53712 4.95206C3.14565 4.5606 3.14367 3.92788 3.5327 3.53886C3.92172 3.14984 4.55443 3.15182 4.9459 3.54328L10.6 9.19603C10.9915 9.58749 10.9935 10.2202 10.6045 10.6092Z",
                    fill: "#8E9CBB",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M10.6127 3.54209C10.2212 3.15062 9.58849 3.14864 9.19947 3.53767L3.53718 9.19996C3.14816 9.58898 3.15014 10.2217 3.54161 10.6132C3.93307 11.0046 4.56579 11.0066 4.95481 10.6176L10.6171 4.95529C11.0061 4.56627 11.0041 3.93356 10.6127 3.54209Z",
                    fill: "#8E9CBB",
                  },
                }),
              ]
            ),
          ]
        ),
        _c("div", { staticClass: "sidesheet__header" }, [
          _vm.title && !_vm.useHtml
            ? _c("div", { staticClass: "sidesheet__title" }, [
                _vm._v(_vm._s(_vm.title)),
              ])
            : _vm._e(),
          _vm.title && _vm.useHtml
            ? _c("div", {
                staticClass: "sidesheet__title",
                domProps: { innerHTML: _vm._s(_vm.title) },
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "sidesheet__actions" },
            [_vm._t("actions")],
            2
          ),
        ]),
        _c(
          "div",
          { staticClass: "sidesheet__content" },
          [_vm._t("default")],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }